module.exports = __webpack_public_path__ + "assets/facebook-614cf5.svg";